import { messageDayBoundary } from '../lib/messageDates';
import '../styles/message-dates.css';

export function MessageDateSeparator({ createdAt, previousCreatedAt }: { createdAt: string; previousCreatedAt?: string }) {
  const day = messageDayBoundary(createdAt, previousCreatedAt);
  if (!day) return null;
  return <div className="message-date-separator" role="separator" aria-label={day.label}><time dateTime={day.key}>{day.label}</time></div>;
}
